import { render, staticRenderFns } from "./InativacaoLote.vue?vue&type=template&id=56b85c57&scoped=true&"
import script from "./InativacaoLote.vue?vue&type=script&lang=js&"
export * from "./InativacaoLote.vue?vue&type=script&lang=js&"
import style0 from "./InativacaoLote.vue?vue&type=style&index=0&id=56b85c57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b85c57",
  null
  
)

export default component.exports